import { flexAlignCenter } from '@commonPackage/styles/utils';
import styled from 'styled-components';

export const SectionContainer = styled.div<{ backgroundImg?: string; height?: number }>`
  height: ${props => props.height || 780}px;
  background-color: var(--white);
  background-image: url(${props => props.backgroundImg || ''});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;

  ${flexAlignCenter('column')};

  h2 {
    color: rgb(51 51 51 / 100%);
    text-align: center;
    font-size: 40px;
    font-weight: 500;
    margin-top: 80px;
  }

  h4 {
    color: var(--text-color-10);
    font-size: var(--font-size-xl);
    font-weight: var(--font-weight-base);
    margin-bottom: 60px;
  }
`;
